export default "https://statics.cloudfastin.top/static/v1.27.38.3-s.dispute.2/store/images/loading.gif?cded2b5869213d137131573ef844d75d";